import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S2-WB2
// (PRA-788). Now served by `api-core-node` at
// `POST /api/firms/google-workspace/credentials/revoke`. See
// `generateGoogleAuthUrl.ts` for the retirement-deferred callable note.

export const revokeGoogleCredentialsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/google-workspace/credentials/revoke',
} as const satisfies BackendRouteDefinition;
